export const getCurrentLocation = state => state.router.location;
